// extracted by mini-css-extract-plugin
export default {"inputDate":"MyDatePicker_inputDate__GkGUN"};